import { render, staticRenderFns } from "./SortenVerteilungModal.vue?vue&type=template&id=0ef0910d&"
import script from "./SortenVerteilungModal.vue?vue&type=script&lang=js&"
export * from "./SortenVerteilungModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports